//@ts-nocheck
import Axios from 'axios';

export const changeCuttingPackageStatus = async (
  cuttingPackageId,
  status,
  onEnd,
  onError,
) => {
  try {
    await Axios.put(`/api/cutting/${cuttingPackageId}/status`, { status });

    onEnd();
  } catch (error) {
    console.log(error.response);
    onError();
  }
};

export const startCuttingWithMaterials = async (
  cuttingPackageId,
  materials,
) => {
  const response = await Axios.post(
    `/api/cutting/${cuttingPackageId}/start-with-materials`,
    {
      materials,
    },
  );
  return response.data;
};

export const adjustMaterialQuantity = async (
  cuttingPackageId,
  materialIndex,
  newQuantity,
  reason,
) => {
  const response = await Axios.put(
    `/api/cutting/${cuttingPackageId}/materials/${materialIndex}/adjust`,
    {
      newQuantity,
      reason,
    },
  );
  return response.data;
};

export const addMaterialToCutting = async (
  cuttingPackageId,
  storageItemId,
  quantity,
  reason,
) => {
  const response = await Axios.post(
    `/api/cutting/${cuttingPackageId}/materials`,
    {
      storageItemId,
      quantity,
      reason,
    },
  );
  return response.data;
};

export const removeMaterialFromCutting = async (
  cuttingPackageId,
  materialIndex,
) => {
  const response = await Axios.delete(
    `/api/cutting/${cuttingPackageId}/materials/${materialIndex}`,
  );
  return response.data;
};
